import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
    getDisplayAddressPasswordAndNickname,
    getDisplayDigitalWalletPaymentOptions,
    getDisplayStandardPaymentMethods,
} from "@qgiv/core-donor";
import { reduxRegistrationsHasCommitments } from "@qgiv/p2p-registration";
import { useFormikContext } from "formik";
import NewPaymentMethod from "./NewPaymentMethod";
import { selectIsCms } from "../../../redux/slices/configSlice";
import { selectShouldDisplayApplePay } from "../../../redux/slices/appSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectRegistrationsFromRegistration } from "../../../redux/slices/registrationSlice";

const ConnectedNewPaymentMethod = ({ controlId }) => {
    const formik = useFormikContext();
    const { values } = formik;
    const isCms = useSelector(selectIsCms);
    const shouldDisplayApplePay = useSelector(selectShouldDisplayApplePay);
    const { enableCommitments } = useSelector(selectAllP2pSettings);
    const {
        enableAchPayments = false,
        enableCCPayments = false,
        enablePaypalPayments = false,
    } = useSelector(selectAllFormSettings);
    const registrations = useSelector(selectRegistrationsFromRegistration);

    // Only render the component if Apple Pay or PayPal is enabled
    const displayDigitalWalletPaymentOptions =
        getDisplayDigitalWalletPaymentOptions({
            enablePaypalPayments,
            shouldDisplayApplePay,
        });
    // Hide all of the payment methods that are not Apple Pay or PayPal
    const displayStandardPaymentMethods = getDisplayStandardPaymentMethods({
        enableAchPayments,
        enableCCPayments,
        isCms,
        values,
    });
    // Only hide the payment address & nickname if a user has selected
    // Apple Pay and the form is not in CMS
    const displayAddressPasswordAndNickname =
        getDisplayAddressPasswordAndNickname({
            isCms,
            values,
        });
    const registrationHasCommitment = !isCms
        ? reduxRegistrationsHasCommitments(registrations)
        : enableCommitments;

    const newPaymentMethodsProps = {
        controlId,
        displayAddressPasswordAndNickname,
        displayDigitalWalletPaymentOptions,
        displayStandardPaymentMethods,
        formik,
        registrationHasCommitment,
    };

    return <NewPaymentMethod {...newPaymentMethodsProps} />;
};

ConnectedNewPaymentMethod.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedNewPaymentMethod;
